export enum JobType {
  UPDATE_OUTDATED_STATUSES_AND_DATES_ON_CONTRACTS = "UPDATE_OUTDATED_STATUSES_AND_DATES_ON_CONTRACTS",
  DELETE_CALC_RECORDS_OLDER_THAN_1_MONTH = "DELETE_CALC_RECORDS_OLDER_THAN_1_MONTH",
  DELETE_CALC_ATTACHMENTS_OLDER_THAN_1_MONTH = "DELETE_CALC_ATTACHMENTS_OLDER_THAN_1_MONTH",
  DELETE_CALC_DRAFTS_OLDER_THAN_6_MONTHS = "DELETE_CALC_DRAFTS_OLDER_THAN_6_MONTHS",
  DELETE_STORAGE_FILES_MARKED_AS_TO_BE_DELETED = "DELETE_STORAGE_FILES_MARKED_AS_TO_BE_DELETED",
  DELETE_JOB_RECORDS_OLDER_THAN_6_MONTHS = "DELETE_JOB_RECORDS_OLDER_THAN_6_MONTHS",
  DELETE_REDUNDANT_CLIENT_ASSIGNED_AGENTS = "DELETE_REDUNDANT_CLIENT_ASSIGNED_AGENTS",
  GENERATE_ANNIVERSARY_DATE_NOTIFICATIONS = "GENERATE_ANNIVERSARY_DATE_NOTIFICATIONS",
  GENERATE_UNPAID_CONTRACTS_NOTIFICATIONS = "GENERATE_UNPAID_CONTRACTS_NOTIFICATIONS",
  GENERATE_UPCOMING_MONTH_PAYMENTS_NOTIFICATIONS = "GENERATE_UPCOMING_MONTH_PAYMENTS_NOTIFICATIONS",
  SEND_SCHEDULED_NOTIFICATIONS = "SEND_SCHEDULED_NOTIFICATIONS",
  SEND_AGENT_ENDING_COMPETENCE_NOTIFICATIONS = "SEND_AGENT_ENDING_COMPETENCE_NOTIFICATIONS",
  SEND_AGENT_ENDING_MENTORING_NOTIFICATIONS = "SEND_AGENT_ENDING_MENTORING_NOTIFICATIONS",
  PROCESS_MONLY_WEBHOOK_EVENT = "PROCESS_MONLY_WEBHOOK_EVENT",
  REFRESH_MONLY_TOKENS_NEAR_EXPIRATION = "REFRESH_MONLY_TOKENS_NEAR_EXPIRATION",
  PROCESS_FINGO_CONTRACTS_EVENT = "PROCESS_FINGO_CONTRACTS_EVENT",
  PROCESS_EUCS_CONTRACTS_SYNC = "PROCESS_EUCS_CONTRACTS_SYNC",
  PROCESS_IAD_CLIENT_TRANSACTIONS = "PROCESS_IAD_CLIENT_TRANSACTIONS",
  PROCESS_EIC_CLIENT_TRANSACTIONS = "PROCESS_EIC_CLIENT_TRANSACTIONS",
  SYNC_PARTNER_SSO_USERS = "SYNC_PARTNER_SSO_USERS",
  EVALUATE_MONTHLY_COMMISSIONS = "EVALUATE_MONTHLY_COMMISSIONS",
  EVALUATE_COMMISSIONS_RANK = "EVALUATE_COMMISSIONS_RANK",
  EVALUATE_COMMISSIONS_LEVEL_PROMOTION = "EVALUATE_COMMISSIONS_LEVEL_PROMOTION",
  EVALUATE_COMMISSIONS_RANK_PROMOTION = "EVALUATE_COMMISSIONS_RANK_PROMOTION",
  EVALUATE_AGENT_EDUCATION = "EVALUATE_AGENT_EDUCATION",
  EVALUATE_AGENT_SECTORS = "EVALUATE_AGENT_SECTORS",
  EVALUATE_CHINA_COMPETITION = "EVALUATE_CHINA_COMPETITION",
  EVALUATE_SLOVENIA_COMPETITION = "EVALUATE_SLOVENIA_COMPETITION",
}

export enum JobState {
  MANUALLY_SCHEDULED = "MANUALLY_SCHEDULED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  ABORTED = "ABORTED",
  TERMINATED_BY_ERROR = "TERMINATED_BY_ERROR",
}
